var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row g-1 wrap"},_vm._l((_vm.icons),function(icon){return _c('FontAwesomeIcon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$tc(`${_vm.id}:${icon}`)),expression:"$tc(`${id}:${icon}`)"}],key:icon,attrs:{"icon":_vm.iconMap[icon]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }